/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BriefResourceProfileDetail
 */
export interface BriefResourceProfileDetail {
    /**
     * 
     * @type {string}
     * @memberof BriefResourceProfileDetail
     */
    jobTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof BriefResourceProfileDetail
     */
    experienceLevel?: BriefResourceProfileDetailExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof BriefResourceProfileDetail
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BriefResourceProfileDetail
     */
    languages?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BriefResourceProfileDetail
     */
    mandatorySkills?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BriefResourceProfileDetail
     */
    bonusSkills?: Array<string>;
}


/**
 * @export
 */
export const BriefResourceProfileDetailExperienceLevelEnum = {
    Entry: 'ENTRY',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT',
    ExpertPlus: 'EXPERT_PLUS'
} as const;
export type BriefResourceProfileDetailExperienceLevelEnum = typeof BriefResourceProfileDetailExperienceLevelEnum[keyof typeof BriefResourceProfileDetailExperienceLevelEnum];


/**
 * Check if a given object implements the BriefResourceProfileDetail interface.
 */
export function instanceOfBriefResourceProfileDetail(value: object): value is BriefResourceProfileDetail {
    return true;
}

export function BriefResourceProfileDetailFromJSON(json: any): BriefResourceProfileDetail {
    return BriefResourceProfileDetailFromJSONTyped(json, false);
}

export function BriefResourceProfileDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): BriefResourceProfileDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'experienceLevel': json['experienceLevel'] == null ? undefined : json['experienceLevel'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'languages': json['languages'] == null ? undefined : json['languages'],
        'mandatorySkills': json['mandatorySkills'] == null ? undefined : json['mandatorySkills'],
        'bonusSkills': json['bonusSkills'] == null ? undefined : json['bonusSkills'],
    };
}

export function BriefResourceProfileDetailToJSON(value?: BriefResourceProfileDetail | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'jobTitle': value['jobTitle'],
        'experienceLevel': value['experienceLevel'],
        'categories': value['categories'],
        'languages': value['languages'],
        'mandatorySkills': value['mandatorySkills'],
        'bonusSkills': value['bonusSkills'],
    };
}

